export const voiceRecorderTranslations = {
  fr: {
    title: "Dictée vocale",
    startRecording: "Commencer l'enregistrement",
    recording: "Enregistrement en cours...",
    recordingInProgress: "Enregistrement en cours...",
    clickToRecord: "Cliquez pour commencer l'enregistrement",
    paused: "En pause",
    transcribing: "Transcription en cours...",
    recordingStarted: "Enregistrement démarré",
    microphoneError: "Erreur d'accès au microphone",
    transcriptionComplete: "Transcription terminée",
    transcriptionEmpty: "Aucun texte transcrit",
    transcriptionError: "Erreur lors de la transcription",
    instructions: "Cliquez pour commencer l'enregistrement. Parlez clairement près du microphone.",
    tip: "Parlez clairement et évitez les bruits de fond pour de meilleurs résultats",
    longRecordingWarning: "Enregistrement long détecté. Considérez arrêter pour économiser les crédits.",
    stop: "Arrêter",
    pause: "Pause",
    resume: "Reprendre",
    reset: "Recommencer",
    streaming: "Mode streaming",
    segmentProcessed: "Segment traité",
    finalTranscription: "Transcription finale"
  },
  
  en: {
    title: "Voice Dictation",
    startRecording: "Start recording",
    recording: "Recording...",
    recordingInProgress: "Recording in progress...",
    clickToRecord: "Click to start recording",
    paused: "Paused",
    transcribing: "Transcribing...",
    recordingStarted: "Recording started",
    microphoneError: "Microphone access error",
    transcriptionComplete: "Transcription completed",
    transcriptionEmpty: "No text transcribed",
    transcriptionError: "Transcription error",
    instructions: "Click to start recording. Speak clearly near the microphone.",
    tip: "Speak clearly and avoid background noise for better results",
    longRecordingWarning: "Long recording detected. Consider stopping to save credits.",
    stop: "Stop",
    pause: "Pause", 
    resume: "Resume",
    reset: "Reset",
    streaming: "Streaming mode",
    segmentProcessed: "Segment processed",
    finalTranscription: "Final transcription"
  },
  
  es: {
    title: "Dictado por voz",
    startRecording: "Iniciar grabación",
    recording: "Grabando...",
    recordingInProgress: "Grabación en progreso...",
    clickToRecord: "Haga clic para iniciar la grabación",
    paused: "Pausado",
    transcribing: "Transcribiendo...",
    recordingStarted: "Grabación iniciada",
    microphoneError: "Error de acceso al micrófono",
    transcriptionComplete: "Transcripción completada",
    transcriptionEmpty: "No se transcribió texto",
    transcriptionError: "Error de transcripción",
    instructions: "Haga clic para iniciar la grabación. Hable claramente cerca del micrófono.",
    tip: "Hable claramente y evite el ruido de fondo para mejores resultados",
    longRecordingWarning: "Grabación larga detectada. Considere detener para ahorrar créditos.",
    stop: "Detener",
    pause: "Pausar",
    resume: "Reanudar", 
    reset: "Reiniciar",
    streaming: "Modo streaming",
    segmentProcessed: "Segmento procesado",
    finalTranscription: "Transcripción final"
  }
};